import { application } from "./application"

import ClickableController from "./clickable_controller"
application.register("clickable", ClickableController)

import FilesController from "./files_controller"
application.register("files", FilesController)

import EncryptedUploadController from "./encrypted_upload_controller"
application.register("encrypted-upload", EncryptedUploadController)

import EncryptedDownloadController from "./encrypted_download_controller"
application.register("encrypted-download", EncryptedDownloadController)

import EncryptedOutboxUploadController from "./encrypted_outbox_upload_controller"
application.register("encrypted-outbox-upload", EncryptedOutboxUploadController)

import EncryptedOutboxDownloadController from "./encrypted_outbox_download_controller"
application.register("encrypted-outbox-download", EncryptedOutboxDownloadController)

import EncryptedExternalDownloadController from "./encrypted_external_download_controller"
application.register("encrypted-external-download", EncryptedExternalDownloadController)

import ScrollProgressController from "./scroll_progress_controller"
application.register("scroll-progress", ScrollProgressController)

import CodeInputController from "./code_input_controller"
application.register("code-input", CodeInputController)

import DropdownController from './dropdown_controller'
application.register("dropdown", DropdownController)

import ThemeInputController from './theme_input_controller'
application.register("theme-input", ThemeInputController)

import FlashController from './flash_controller'
application.register("flash", FlashController)

import FormController from './form_controller'
application.register("form", FormController)

import MultiInput from './multi_input_controller'
application.register("multi-input", MultiInput)

import TableController from './table_controller'
application.register("table", TableController)

import IframeResizeController from "./iframe_resize_controller";
application.register("iframe-resize", IframeResizeController);

import CopyController from "./copy_controller";
application.register("copy", CopyController);

import ConfirmController from "./confirm_controller";
application.register("confirm", ConfirmController);

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import AccessVerificationController from "./access_verification_controller";
application.register("access-verification", AccessVerificationController);

import MobileMenuController from "./mobile_menu_controller";
application.register("mobile-menu", MobileMenuController);

import TooltipController from "./tooltip_controller";
application.register("tooltip", TooltipController);

import PasskeyController from "./passkey_controller";
application.register("passkey", PasskeyController);

import SessionController from "./session_controller";
application.register("session", SessionController);

import UserApprovalController from "./user_approval_controller";
application.register("user-approval", UserApprovalController);

import CookieConsentController from "./cookie_consent_controller";
application.register("cookie-consent", CookieConsentController);

import ProgressBarController from "./progress_bar_controller";
application.register("progress-bar", ProgressBarController);

import UploadProgressController from "./upload_progress_controller";
application.register("upload-progress", UploadProgressController);

import DocumentRequestUploadController from "./document_request_upload_controller";
application.register("document-request-upload", DocumentRequestUploadController);

import PreserveHashController from "./preserve_hash_controller";
application.register("preserve-hash", PreserveHashController);

import FaqSearchController from "./faq_search_controller";
application.register("faq-search", FaqSearchController);
